import React  from 'react';
import { Button, Div } from '@vkontakte/vkui';
import DefaultPanel from "../classes/DefaultPanel";
import LoaderSpinner from "../components/LoaderSpinner";
import Icon16Clear from '@vkontakte/icons/dist/16/clear';
import Icon16CheckCircle from '@vkontakte/icons/dist/16/check_circle';
import { connect } from "react-redux";
import { getMoneyTransaction } from "../services/db";
import { addBillAtStart } from "../store/bills/actions";
import { getQRCode} from "../services/vk";


class PanelPayProcess extends DefaultPanel {

	state = {
		status: 0,  // 0 - in progress, 1 - success, 2 - fail
		error: '',
	};

	settings() {
		this.title = 'Результат платежа';
		this.theme = 'gray';
		this.hasSwipe = false;
	}

    openBills = () => {
        this.openPage('main');
    };

	getMoney = async() => {
        await this.setState({ status: 0 });
		// Сканируем код
		let scanResult;
        if (process.env.NODE_ENV === 'development') {
            scanResult = { qr_data: '4267535,9676,0,f73ee6' };
        } else {
        	scanResult = await this.props.dispatch(getQRCode());
		}

        // Проверяем правильный ли код отсканирован
        const checkStatus = await this.checkResult(scanResult);

        if (checkStatus['result'] === 'success') {

        	// Делаем операцию перевода
            const billResult = await this.props.dispatch(getMoneyTransaction(checkStatus.qr, this.props.cashierId, this.props.paySum));

            // Если успешно
            if (billResult.data.data.result !== undefined && billResult.data.data.result === 'success') {
                const bill = billResult.data.data.bill;
                if (bill.id !== undefined) {
                    // Изменяем массив
                    this.props.dispatch(addBillAtStart(bill));
                }
                this.setState({ status: 1 });
            } else {
                this.setState({ status: 2, error: billResult.data.data.error });
            }
        } else {
            this.setState({ status: 2, error: checkStatus.error });
        }
	};

	checkResult = (resultData) => {
		if (resultData.qr_data === undefined) return { result: 'fail', error: 'wrong_qr_code' };

		const result = resultData.qr_data.split(',');

        if (result[0] === undefined || result[1] === undefined || result[2] === undefined || result[3] === undefined || result[0] === '' || result[1] === '' || result[2] === '' || result[3] === '') return { result: 'fail', error: 'wrong_qr_code' };
		// Проверяем ID
		if (result[0] === 0 || result[0] === '') return { result: 'fail', error: 'wrong_vk_id' };
		// Проверяем время
        const now = Math.floor(new Date().getTime() / 1000).toString().substr(-4);
		if (+result[1] + 300 < +now) return { result: 'fail', error: 'wrong_time' };
        // Проверяем деньги
        const isGreater = this.props.paySum > 3000 ? 1 : 0;
        if (+result[2] !== isGreater) return { result: 'fail', error: 'wrong_amount' };

	    return { result: 'success', qr: resultData.qr_data };
    };

	componentWillMount() {
        this.getMoney();
	}

	renderPanel() {
		const inProcess =
			<div>
				<LoaderSpinner/>
				<div>Оплата...</div>
			</div>;

        const success =
            <div>
				<div className="icon-success"><Icon16CheckCircle/></div>
                <div className="text">Успешно</div>
				<Div className="btn-back"><Button size="xl" onClick={ this.openBills }>Назад</Button></Div>
            </div>;

		let errorTxt = '';
		switch (this.state.error) {
			case 'wrong_qr_code':
                errorTxt = 'Неправильный QR-код. Попросите клиента открыть приложение VK и нажать на «Мой QR-код»';
				break;
            case 'wrong_vk_id':
                errorTxt = 'Неправильный QR-код. Попросите клиента открыть приложение VK и нажать на «Мой QR-код»';
                break;
            case 'wrong_time':
                errorTxt = 'QR-код открыт дольше пяти минут. Попросите клиента закрыть его и открыть снова';
                break;
			case 'wrong_amount':
                errorTxt = 'Попросите клиента сдвинуть ползунок «Покупка более 3 000 ₽» и попробуйте снова';
                break;
			case 'insufficient_funds':
                errorTxt = 'Недостаточно средств';
                break;
            default:
                errorTxt = 'Неизвестная ошибка, код (' + this.state.error + '). Обратитесь к сотрудникам VK Pay';
                break;
		}

        const fail =
            <div>
				<div className="icon-fail"><Icon16Clear/></div>
                <div className="text">Не удалось</div>
                <div className="error">Ошибка: { errorTxt }</div>
                <Div>
				    <div className="btn-again"><Button size="xl" onClick={ this.getMoney }>Еще раз</Button></div>
				    <div className="btn-back"><Button size="xl" level="secondary" onClick={ this.openBills }>Назад</Button></div>
                </Div>
            </div>;

		return(
			<React.Fragment>
				<div className="center-block">
					{ this.state.status === 0 && inProcess }
					{ this.state.status === 1 && success }
					{ this.state.status === 2 && fail }
				</div>
			</React.Fragment>
		)
	}
}

function mapStateToProps(state) {
    return {
        paySum: state.bills.paySum,
        sum: state.bills.paySum,
        cashierId: state.cashier.cashier.cashier_id,
    };
}

export default connect(mapStateToProps)(PanelPayProcess);


// WEBPACK FOOTER //
// ./src/js/panels/PanelPayProcess.js